import React, {useState} from 'react'
import DHButtonSave from "../../../general/DHButtonSave";
import {Tooltip} from "@mui/material";
import DHDialog from "../../../general/DHDialog";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import DateUtil from "../../../../util/DateUtil";
import DHDateTimePicker from "../../../general/DHDateTimePicker";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";

export default function ChangeGameTimeComp({spiel, onRefresh}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [showDialog, setShowDialog] = useState(false);
    const [working, setWorking] = useState(false);
    const [gametime, setGametime] = useState(undefined);


    const save = () => {
        setErrorMessage(undefined);
        setWorking(true);
        let data = {gameTime : gametime};
        let url = ConfigUtil.getConfig().resourceUrls.league + "/liga/spiel/gametime/change/" + spiel.id;
        FetchUtil.fetchPost(url,
            data,
            () => {
                setInfoMessage("Speichern erfolgreich");
                setWorking(false);
                setShowDialog(false);
                onRefresh();
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
                setWorking(false);
                setShowDialog(false);
            },
            error => {
                setErrorMessage("Fehler: " + error.message)
                setWorking(false);
                setShowDialog(false);
            });
    }

    const isSaveDisabled = () => {
        return !gametime;
    }

    const getDataArea = () => {
        return <div>
            <div style={{marginBottom:20}}>Alter Spielzeitpunkt: {DateUtil.localDateTimeToString(spiel.gametime)}</div>
            <div>
                <DHDateTimePicker value={gametime} label="Spielzeitpunkt" changeValue={(value) => setGametime(value)}/>
            </div>
        </div>
    }

    return <>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)}
                            onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <Tooltip title="Spielzeit ändern">
            <AccessAlarmIcon style={{marginRight:10, cursor:"pointer"}} onClick={() => setShowDialog(true)} />
        </Tooltip>
        {showDialog && <DHDialog showCloseButton={true} title="Spielzeit ändern" onClose={() => setShowDialog(false)}
                                 buttons={
            [<DHButtonSave working={working} onClick={() => save()} disabled={isSaveDisabled()}/>]}
                                 comp={<>
                                     {getDataArea()}
                                 </>}/>
        }
    </>
}